import setupAxios from '../../../../lib/redux/setupAxios'

export const authLogin = async (formData) => {
    return setupAxios.post(`/login`, formData).then((res) => res?.data?.data)
}

export const loadUserByToken = async () => {
    return setupAxios.get('/users/current_user').then((res) => res?.data?.data)
}
export const authLogout = async () => {
    return setupAxios.post('/logout')
}



export const fetchUserInfo = async ({ username, email }) => {
    const params = {};
  
    if (username) params.username_tx = username;
    else if (email) params.email_tx = email;
    else throw new Error('username or email must be provided');
  
    const response = await setupAxios.get(
      '/get_user_info_by_username_or_email',
      { params }
    );
  
    return response.data;
  };


// Submit forgot password (initial or resend)
export const sendForgotPassword = async ({ phone_tx, username_tx, email_tx, resend_token = false }) => {
    const payload = { phone_tx, username_tx };
    if (email_tx) payload.email_tx = email_tx;
    if (resend_token) payload.resend_token = true;
  
    const res = await setupAxios.post(`/forgot_password`, payload);
    return res.data;
  };
  
  // Verify OTP
  export const verifyOtp = async ({ phone_tx, username_tx, otp }) => {
    const res = await setupAxios.post(`/verify_otp`, {
      phone_tx,
      username_tx,
      OTP: otp, // Fix is here
    });
    return res.data;
  };
  
  export const resendEmail = async ({ username_tx }) => {
    const res = await setupAxios.post(`/resend_email`, { username_tx });
    return res.data;
  };
  